/**
 * Immer Configuration
 *
 * This must be imported before any Zustand stores that use Maps/Sets
 */

import { enableMapSet } from "immer";

// Enable MapSet plugin for all stores
enableMapSet();
